/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import SimpleImageSlider from "react-simple-image-slider";

function Gallery({ imageUrl }) {
  const imagesGallery = imageUrl.map((item) => item.image_property);
  const getPics = (data) => {
    const vals = [];
    for (let i = 0; i < data?.length; i++) {
      vals.push({
        url: `${data[i]}`,
      });
    }
    return vals;
  };
  const images = getPics(imagesGallery);

  return (
    <>
      <SimpleImageSlider
        width={`${34}%`}
        height={250}
        images={images}
        showBullets={false}
        showNavs
        navSize={40}
        navMargin={5}
      />
    </>
  );
}

export default Gallery;
